var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJournalsBarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 33,
    viewBox: "0 0 39 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.91176C0 1.30364 1.30957 0 2.925 0H36.075C37.6904 0 39 1.30364 39 2.91176C39 4.51989 37.6904 5.82353 36.075 5.82353H2.925C1.30957 5.82353 0 4.51989 0 2.91176Z",
    fill: "#EFBC51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95 16.5C1.95 14.8919 3.25957 13.5882 4.875 13.5882H34.125C35.7404 13.5882 37.05 14.8919 37.05 16.5C37.05 18.1081 35.7404 19.4118 34.125 19.4118H4.875C3.25957 19.4118 1.95 18.1081 1.95 16.5Z",
    fill: "#EFBC51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 30.0882C3.9 28.4801 5.20957 27.1765 6.825 27.1765H30.225C31.8404 27.1765 33.15 28.4801 33.15 30.0882C33.15 31.6964 31.8404 33 30.225 33H6.825C5.20957 33 3.9 31.6964 3.9 30.0882Z",
    fill: "#EFBC51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalsBarIcon);
export default __webpack_public_path__ + "static/media/journalsBarIcon.136be6801b7d1c8181e939dbdbfaffaa.svg";
export { ForwardRef as ReactComponent };